import { CDN_URL } from 'settings';

export const getUrlCountryImage = (isoAlpha2: string) => {
  return `${CDN_URL}/sun/flags/${isoAlpha2.toLocaleLowerCase()}.png`;
};
